import { call, put, takeLatest } from 'redux-saga/effects';
import { fetchLegalEntitiesFailure, fetchLegalEntitiesSuccess } from '../actions';
import * as constants from '../constants';
import { makeRequest } from '../utils';

function* getLegalEntitiesSaga(action: { type: string; payload: { country: string } }) {
  const { country } = action.payload;

  const url = `https://api-eu.carlsbergwebservices.com/ct/prd/ct-serv-legal-pol-be/api/legal-entities/${country}`;

  try {
    const data = yield call(makeRequest, url);
    yield put(fetchLegalEntitiesSuccess(data));
  } catch (error: any) {
    console.error(error);
    console.error('error fetching legal entities');
    yield put(fetchLegalEntitiesFailure(error.message));
  }
}

function* legalEntitiesSaga() {
  yield takeLatest(constants.FETCH_LEGAL_ENTITIES, getLegalEntitiesSaga);
}

export { legalEntitiesSaga };
